import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

import { useRoot } from '@models/useRoot';
import { CourseListMapModel } from './CourseListMap';

export class Courses extends Model({
  listsMap: types.optional(CourseListMapModel, {}),
}) {}

export const CoursesModel = model(Courses);

export const useCoursesModel = () => {
  const root = useRoot();

  return root.courses;
};
